import { getContent } from '@ynap/content-state';
import { formatDate } from '@ynap/intl-formatters';

const privacyKey = 'consents-privacy-settings-collection';

export default function getPrivacySettings(state) {
    const { locale, content, country } = state;
    const { user } = state;
    const dateFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };

    let consentDatestamp = null;
    if (user && user.contextAttribute) {
        const consentEntry = user.contextAttribute.filter(({ attributeName }) => attributeName === 'externalConsentAcceptTime');
        consentDatestamp = consentEntry.length > 0 ? consentEntry[0].attributeValue[0].value[0] : undefined;
    }

    return {
        locale,
        country,
        content: content ? getContent(state, privacyKey) : undefined,
        isFetchingContent: content?.[privacyKey]?.loading || false,
        fetchContentError: content?.[privacyKey]?.error || false,
        consentTime: user && consentDatestamp && formatDate(new Date(consentDatestamp), dateFormatOptions, locale.id),
    };
}
